import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';

import { selectFilters } from '../../../selectors/filters';

export function useButtonText() {
  const isDesktop = useIsDesktop();
  const { estimationTarget } = useSelector(selectFilters);

  if (isDesktop) {
    return 'Оценить';
  }

  if (estimationTarget === EEstimationTargets.newbuilding) {
    return 'Оценить ЖК';
  }

  return 'Оценить';
}
